<cp-auth-page-common>

  <div class="AuthPageControlsContainer">
    @if (inProgress()) {
      <fa-icon class="Spinner"
               [icon]="faSpinnerThird" animation="spin"></fa-icon>
      <span class="BasisGrotesqueProBold FontSize_Rem_0_875" style="text-align: center;">
        {{ 'DESIGN_B.USER_LOGIN.KEYCLOAK_MESSAGE' | translate }}
      </span>
    } @else {
      <span class="BasisGrotesqueProBold FontSize_Rem_0_875" style="padding: 1rem 0;">
        {{ 'DESIGN_B.USER_LOGIN.KEYCLOAK_RETRY_MESSAGE' | translate }}
      </span>
      <cp-button [style]="ButtonStyle.SECONDARY"
                 [text]="'DESIGN_B.USER_LOGIN.KEYCLOAK_RETRY_BUTTON' | translate"
                 (buttonClick)="onManualRetryClick()">
      </cp-button>
    }
  </div>
</cp-auth-page-common>
